/* eslint-disable import/no-anonymous-default-export */
import Workflows from "./Workflows";
import Placeholders from "./Placeholders";
export default {
    id: 115,
    title: 'Non-Conformance',
    path: 'non-conformance',
    icon: "flaticon2-cancel",
    workflows: Workflows,
    placeholders: Placeholders,
};